<template>
  <div class="main">
    <toptab></toptab>
    <div class="newwhiteouter">
      <div id="demo" class="carousel slide" data-ride="carousel">
        <!-- 指示符 -->
        <ul class="carousel-indicators" style="bottom:-70px">
          <template v-for="(item,index) in projectbanner">
            <!-- <li data-target="#demo" :data-slide-to="index" class="active" :key="index"></li> -->
            <li data-target="#demo" :data-slide-to="index" :class="index==0? 'active':'' " :key="index"></li>
          </template>
        </ul>

        <!-- 轮播图片 -->
        <div class="carousel-inner">
          <template v-for="(item,index) in projectbanner">
            <div
              class="carousel-item"
              :class="index==0? 'active':'' "
              :key="index"
              :style="'background: #fff url('+item.image+') center center no-repeat;'"
              @click="goDeatil('projectdetail',item.id)"
            >
              <div class="text paddingallll">
                <div class="textitle animated fadeInUp">
                  <b>{{item.title}}</b>
                </div>
                <div class="textinfo animated fadeInUp">{{item.little_title}}</div>
                <!-- <div class="textimg animated fadeInUp">
                  <a href="javascript:void(0);">
                    <img src="/static/index/more2.png" />
                  </a>
                </div>-->
              </div>
              <div class="blackcover"></div>
            </div>
          </template>
        </div>
        <!-- 左右切换按钮 -->
        <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev" style="z-index:40">
          <img src="/static/左箭头.png" style="width:60px;height:70px" />
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next" style="z-index:40">
          <img src="/static/右箭头.png" style="width:60px;height:70px" />
        </a>-->
      </div>
    </div>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="maintitle animated fadeInUp">
          <b>招聘理念</b>
        </div>
        <div class="maininfo animated fadeInUp">寻求有相同渴望发展、渴望成功、渴望实现人生价值的人才，在这个快速发展的时代，让</div>
        <div class="maininfo animated fadeInUp">我们携手同行、创造美好的未来！</div>
        <div class="mainlist">
          <div class="mainitem animated fadeInUp">
            <div class="zyjm-kefu mainitemicon"></div>
            <div class="mainiteminfo">
              <div class="mainitemtitle">
                <b>客服电话</b>
              </div>
              <div class="mainitemdetail">您可以来电资讯我们</div>
              <div class="mainitemphoto">
                电话：
                <span>{{info.phone +"，"+ info.tel}}</span>
                <!-- <span>{{detail[1].phone}}</span> -->
              </div>
            </div>
          </div>
          <div class="mainitem animated fadeInUp">
            <div class="zyjm-youjian mainitemicon"></div>
            <div class="mainiteminfo">
              <div class="mainitemtitle">
                <b>投递邮箱</b>
              </div>
              <div class="mainitemdetail">您可以把简历或个人信息编辑发送到人力资源部邮箱</div>
              <div class="mainitemphoto">
                邮箱：
                <span>{{info.email}}</span>
                <!-- <span>{{detail[1].email}}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div class="joblist animated fadeInUp">
          <template v-for="(item,index) in joblist">
            <jobitem :key="index" :job="item"></jobitem>
          </template>
        </div>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import jobitem from "../components/job-item";
import footeritem from "../components/footer-item";
export default {
  components: {
    toptab,
    footeritem,
    jobitem
  },
  data() {
    return {
      projectbanner: [],
      joblist: [],
      detail: [],
      info: ""
    }
  },
  created() {
    this.loadData();
  },
  beforeCreate() {
    // this.$router.go(0)
    // location.href = "/#/" + '?time=' + ((new Date()).getTime());
    if (window.isFirst) {
      // this.$router.go(0)
      window.location.reload()
    }
  },
  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.recruitmentBanner, {})
        .then(res => {
          console.log(res.data);
          let { error_code, banners } = res.data;
          if (error_code == 2001) {
            this.projectbanner = banners
          }
        });
      this.$axios.post(this.$url.contactInformation, {})
        .then(res => {
          console.log(res.data);
          let { error_code, msg } = res.data;
          if (error_code == 2001) {
            this.detail = msg
          }
        });
      this.$axios.post(this.$url.recruitmentMsg, {})
        .then(res => {
          console.log(res.data);
          let { error_code, recruitment } = res.data;
          if (error_code == 2001) {
            this.joblist = recruitment
          }
        });
      this.$axios.post(this.$url.contactInformation, {})
        .then(res => {
          console.log(res.data);
          let { error_code, msg } = res.data;
          if (error_code == 2001) {
            this.info = msg
          }
        });
    },
  }
}
</script>

<style scoped>
@import "../css/padding.css";
@import "../css/animate.min.css";

.main {
  padding-top: 0.67rem;
}

#demo {
  width: 1920px;
  height: 492px;
  margin: 0 auto;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner {
  width: 100%;
  height: 492px;
  /* position: relative; */
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner .carousel-item {
  padding-top: 1rem;
  width: 100%;
  height: 492px;
  background-size: cover;
  /* max-height: 1080px;
  min-height: 8.6rem; */
  position: relative;
}
#demo .carousel-inner .text {
  width: 1440px;
  /* margin: 0 auto; */
  font-size: 40px;
  color: white;
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#demo .carousel-inner .text .textitle {
}

#demo .carousel-inner .text .textinfo {
}

/* #demo .carousel-inner .text .textimg {
  width: 1.8rem;
  height: 0.46rem;
  margin-top: 1.5rem;
}

#demo .carousel-inner .text .textimg img {
  width: 1.8rem;
  height: 0.46rem;
} */

.blackcover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(49, 50, 51, 0.5);
}

.textitle {
  font-size: 0.6rem;
  margin-bottom: 0.58rem;
  text-align: center;
}
.textinfo {
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.4rem;
}

.newwhiteouter {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  height: 492px;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}

.mainouter {
  width: 100%;
  padding: 1rem 0;
}
.whiteback {
  background-color: #fff;
}
.grayback {
  background-color: #f5f5f5;
}
.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}
.maintitle {
  font-size: 0.3rem;
  text-align: center;
  margin-bottom: 0.2rem;
}
.maininfo {
  text-align: center;
  font-size: 0.18rem;
}
.mainlist {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0.4rem 0;
}
.mainitem {
  display: flex;
  width: 100%;
  max-width: 48%;
  padding: 0.2rem 0.4rem;
  background-color: #fff4ed;
}
.mainitemicon {
  font-size: 1rem;
  line-height: 1.2rem;
  height: 1.2rem;
  color: #ffd3b4;
  margin-right: 0.2rem;
}
.mainitemtitle {
  margin-bottom: 0.05rem;
  font-size: 0.2rem;
  margin-top: 0.1rem;
}
.mainitemdetail {
  font-size: 0.14rem;
  color: #89837f;
  margin-bottom: 0.1rem;
}
.mainitemphoto {
  font-size: 0.14rem;
  color: #89837f;
}
.mainitemphoto span {
  font-size: 0.14rem;
  color: #ff9867;
}
@media (max-width: 1440px) {
  .threelist {
    width: 100%;
  }
  #demo .carousel-inner .text {
    width: 100%;
  }
  .firstinfo {
    width: 100%;
  }
}

@media (max-width: 1920px) {
  #demo {
    width: 100%;
  }

  #topdemo {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .main {
    padding-top: 100px;
  }
  .maintitle {
    font-size: 60px;
  }
  .maininfo {
    font-size: 40px;
  }

  .mainlist {
    flex-direction: column;
    justify-content: center;
  }
  .mainitem {
    max-width: 100%;
    padding: 0.4rem 0.8rem;
    margin: 20px auto;
  }

  .mainitemicon {
    font-size: 2rem;
    line-height: 2rem;
    height: 2rem;
    color: #ffd3b4;
    margin-right: 0.2rem;
  }
  .mainitemtitle {
    margin-bottom: 0.05rem;
    font-size: 50px;
    margin-top: 0;
  }
  .mainitemdetail {
    font-size: 30px;
    color: #89837f;
    margin-bottom: 0.1rem;
  }
  .mainitemphoto {
    font-size: 30px;
    color: #89837f;
  }
  .mainitemphoto span {
    font-size: 30px;
    color: #ff9867;
  }
  .textinfo {
    font-size: 0.4rem;
  }
  .paddingallll {
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
}

@media (max-width: 1300px) {
  #demo .carousel-inner .carousel-item {
    padding-top: 1.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruitment.vue